import { AbacoWebModule, RouterReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import { createMenu } from './menu';
import FarmRegistryModule from "@abaco/farm-registry/src/modules/farm-registry/index";
import { HTTPClient } from '@abaco/web-common/src/HTTP';

export const MODULE_ID = "unaprol_embedded_sections_module";

export default class UnaprolEmbeddedSectionsModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;
    readonly routes = myRoutes;
    menu: MenuItem[] = [];
    
    http!: HTTPClient;

    dependsOn = {
        [FarmRegistryModule.MODULE_ID]: () => new FarmRegistryModule
    }

    onRouterReady(evt: RouterReadyEvent) {
        this.menu = createMenu(evt.router);
        this.http = evt.http;
    }

    public async getHortaServiceInfo(subjectId: number){
        const url = `/sitiagri-rest-api/api_basic/v1/horta/get_service/${subjectId}`;
        const res = await this.http.get(url)
        return res.data.completeUrl;
    }

}
